import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_RS: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitnes',
  components_header_media_1: 'Za muškarce',
  components_header_media_2: 'Za žene',
  components_header_media_multi_content_2: 'Joga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Trenirajte pametnije, osećajte se bolje.',
  hero_button_text: 'Počnite sada',
  components_ressources_subheader_text: 'Vodiči i saveti',
  components_ressources_span_text: 'Kombinuje zemaljski fokus joge, kontrolisanu preciznost pilatesa i dinamičan izazov treninga snage kako bi podržao sveobuhvatan i zdrav način života.',
  components_ressources_card_1_title: 'Saveti za jogu',
  components_ressources_card_1_text: 'Kratki vodič za bolju ravnotežu, disanje i protok.',
  components_ressources_card_2_title: 'Pilates saveti',
  components_ressources_card_2_text: 'Jednostavni saveti za jačanje mišića trupa i poboljšanje kontrole.',
  components_notes_and_google_title_1: 'Izgradite snagu',
  components_notes_and_google_title_2: 'Joga mir',
  components_notes_and_google_title_3: 'Pilates jezgro',
  media_content_section_multi_1_subheader_text: 'Video snimci za obuku',
  media_content_section_multi_2_subheader_text: 'Video snimci o jogi',
  media_content_section_multi_3_subheader_text: 'Pilates video snimci',
  text_media_1: 'Muškarci',
  text_media_2: 'Žene',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Nazad',
  page_media_content_menu_chest: 'Grudi',
  page_media_content_menu_legs: 'Noge',
  page_media_content_menu_shoulders: 'Ramena',
  page_media_content_menu_abdominals: 'Abdominals',
  components_text1_subheader_text: 'Zdrava ishrana za vaš aktivan život',
  components_text1_span_text: 'Zdravi recepti koji podržavaju vaš trening i poboljšavaju vaše blagostanje.',
  components_footer_text: 'Ojačajte svoje telo, uravnotežite svoj um i krećite se sa smislom – vaše mesto za teretanu, jogu i pilates.',
};